var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.buttonLink)?_c('a',{staticClass:"btn -purple -outline email-button",attrs:{"href":_vm.buttonLink,"target":"_blank"}},[_c(_vm.buttonIcon,{tag:"component"}),_c('span',[_vm._v(_vm._s(_vm.$tc('auth.goToMail')))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }